// extracted by mini-css-extract-plugin
module.exports = {"card":"qA-z"};